export default __webpack_public_path__ + "151406f16339507c38c621daf8b0e253.png";